// react icons
import { LiaProjectDiagramSolid } from "react-icons/lia";

const aboutCardData = [
  {
    id: 1,
    icon: <LiaProjectDiagramSolid />,
    title: "Experience",
    desc: "4+ years",
  },
  {
    id: 2,
    icon: <LiaProjectDiagramSolid />,
    title: "Completed",
    desc: "600+ projects",
  },
];

export default aboutCardData;
